import { render, staticRenderFns } from "./CompanyMetricsBtns.vue?vue&type=template&id=11709c4e&scoped=true"
import script from "./CompanyMetricsBtns.vue?vue&type=script&lang=ts"
export * from "./CompanyMetricsBtns.vue?vue&type=script&lang=ts"
import style0 from "./CompanyMetricsBtns.vue?vue&type=style&index=0&id=11709c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11709c4e",
  null
  
)

export default component.exports